window.addEventListener('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});

window.addEventListener('pageshow', function(event) {
  const scrollPosition = sessionStorage.getItem('scrollPosition');

  if (event.persisted && scrollPosition) {
    setTimeout(function() {
      window.scrollTo(0, parseInt(scrollPosition, 10));
      sessionStorage.removeItem('scrollPosition');
    }, 100);
  } else {
    sessionStorage.removeItem('scrollPosition');
  }
});
